import getPathWithQueryLocationUtil from 'modules/location/utils/get-path-with-query'

function getEndpointTrainingUtil (pathname, query) {
  return getPathWithQueryLocationUtil(TRAINING_API_ENDPOINT + pathname, query)
}

export default getEndpointTrainingUtil
